import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "compare_cars_v1";
const MAX = 3;
const ComparisonContext = createContext({
  ids: [],
  add: () => {},
  remove: () => {},
  clear: () => {},
  has: () => false,
  canAddMore: false,
  max: MAX,
});

export function ComparisonProvider({ children }) {
  const [ids, setIds] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) setIds(arr.slice(0, MAX));
      }
    } catch {
      /* ignore */
    }
  }, []);

  const persist = useCallback((arr) => {
    setIds(arr);
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch {
      /* ignore */
    }
  }, []);

  const add = useCallback((id) => {
    if (!id) return;
    setIds((prev) => {
      if (prev.includes(id)) return prev;
      const next = [...prev, id].slice(0, MAX);
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch { /* ignore */ }
      return next;
    });
  }, []);

  const remove = useCallback((id) => {
    setIds((prev) => {
      const next = prev.filter((x) => x !== id);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  }, []);

  const clear = useCallback(() => persist([]), [persist]);

  const has = useCallback((id) => ids.includes(id), [ids]);

  return (
    <ComparisonContext.Provider value={{ ids, add, remove, clear, has, canAddMore: ids.length < MAX, max: MAX }}>
      {children}
    </ComparisonContext.Provider>
  );
}

export const useComparison = () => useContext(ComparisonContext);
